package de.emgress.baskets.modules.components

import androidx.compose.runtime.Composable
import de.emgress.baskets.core.styles.Styles
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun CountdownComponent(
    dateTimeName: String,
    dateTimeValue: Int
) {
    Div({ classes(Styles.cssClasses.column, Styles.cssClasses.horizontalDynamicMarginSmall) }) {
        P({
            classes(Styles.cssClasses.largeParagraph, Styles.cssClasses.bold, Styles.cssClasses.passionOneFont, Styles.cssClasses.orangeFont)
        }) {
            Text(dateTimeValue.toString())
        }
        P({
            classes(Styles.cssClasses.paragraph, Styles.cssClasses.barlowFont, Styles.cssClasses.orangeFont)
        }) {
            Text(dateTimeName)
        }
    }
}